import { render } from "./MyTicket.vue?vue&type=template&id=6573d661"
import script from "./MyTicket.vue?vue&type=script&lang=js"
export * from "./MyTicket.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__